<template lang="pug">
    div
        data-table-filters(
            :filters="propFilters" 
            @filter="activeFilters = $event"
            @search="handleSearch($event)"
            :noSearchBox="noSearchBox"
            :filterOnChange="filterOnChange"
            @filters:show="showFilters = $event"
            )
        div(
            :style="{'margin-top': exportButtonMargin}"
            style="width: 100%; display:flex; justify-content:flex-end;"
            )
            v-btn(
                v-if="!noVisualHelp"
                @click="toggleVisualHelp()"
                :color="colors.primary"
                dark
                )
                v-icon(left) zoom_in 
                span.pt-1    Apoyo Visual
            v-btn(
                v-if="!noExport"
                @click="printExcel()"
                :color="colors.primary"
                dark) 
                v-icon(left ) grid_on
                span.pt-1 Exportar
        data-table-pagination(
            v-if="!showAll" 
            v-model="pagination" 
            :length="apiData.lastPage" 
            :from="apiData.from" :to="apiData.to" 
            :total="apiData.total"
            )
        //TABLE
        div.table-container(
            style="overflow-x: auto; width: calc(100vw - 120px);"
            :class="{'visual-help-mode': visualHelpMode}"
            )
            
            //TABLE HEADERS
            div.header-row(
                :style="headerLayout ? headerLayout : gridLayout.headers"
                )    
                div.dtheader.pl-2(
                    v-if="checkable" 
                    :class="headerClasses"
                    )
                    v-checkbox(
                        dark 
                        color="white" 
                        @change="checkAll()" 
                        :indeterminate="headerCheckboxIndeterminate"
                        value="allChecked"
                    )
                div.dtheader.px-3(
                    v-for="(header, idx) in activeHeaders" 
                    :key="idx" :class="headerClasses"
                    @click="sort(header)"
                    style="font-size: 15px;"
                    )
                    div.header-wrapper(
                        style="width: 100%; height: 100%; display: flex; align-items: center;"
                        :class="{pointer: header.sortable}"
                        )
                        span {{header.text}}
                        v-icon(
                            style="color: inherit;"
                            size="20"
                            v-if="header.sortable && pagination.sortBy === header.value"
                            right
                            ) {{pagination.descending ? 'arrow_downward' : 'arrow_upward'}}
                div.dtheader.px-3.col-actions(
                    :class="headerClasses" 
                    v-if="!noActions"
                    style="font-size: 15px;"
                    )
                    span Acciones
            .loader-area(v-if="loading" :style="expandableColSpan" style="position: absolute; width: 200px; z-index: 10; left: calc(50% - 100px)")
                LoadingDialog(:loading="loading")
            div.body-rows(
                style="width: auto; overflow-y: auto; overflow-x: visible;"
                :style="{'width': bodyWidth, 'max-height': 'calc(100vh - ' + (this.showAll ? '200' : '300') + 'px)'}"
            )
                
                //TABLE BODY
                div.custom-datatable(
                    :style="gridLayout.body"                    
                    )
                    
                    //FAKE HEADERS FOR WIDTH ADJUSTING
                    div.dtheader.pl-2(
                        v-if="checkable" 
                        :class="headerClasses"
                        style="opacity: 0; pointer-events: none;"
                        )
                        v-checkbox(
                            dark 
                            color="white" 
                            @change="checkAll()" 
                            :indeterminate="headerCheckboxIndeterminate"
                            value="allChecked"
                        )
                    div.dtheader.px-3(
                        v-for="(header, idx) in activeHeaders" 
                        :key="idx" :class="headerClasses"
                        @click="sort(header)"
                        )
                        div.header-wrapper(
                            style="width: 100%; height: 100%; display: flex; align-items: center;"
                            :class="{pointer: header.sortable}"
                            )
                            span.white--text {{header.text}}
                            v-icon(
                                style="color: inherit;"
                                size="20"
                                v-if="header.sortable && pagination.sortBy === header.value"
                                right
                                ) {{pagination.descending ? 'arrow_downward' : 'arrow_upward'}}
                    div.dtheader.px-3.col-actions(
                        :class="headerClasses" 
                        v-if="!noActions"
                        )
                        span Acciones
                    
                    //TABLE ROWS
                    template(
                        v-for="(item, idx) in items"
                        )
                        div.dtcell.col-actions.pl-2.left-cell(
                            v-if="checkable"
                            :class="{'selected-row': item.checked }"
                            )
                            v-checkbox(
                                v-model="item.checked" 
                                @change="selectRow(item)"
                                :color="colors.success"
                                )
                        div.dtcell.px-3(
                            v-for="(header, index) in activeHeaders"
                            :ref="idx === 0 ? 'col' + index : null"
                            :style="{'cursor': (expandable && header && header.expand) ? 'pointer' : 'auto', 'text-overflow': 'elipsis', 'text-align': header.align || 'left'}"
                            @click="(expandable && header && header.expand) ? expandRow(idx) : ''"
                            :class="{'selected-row': item.checked, 'left-cell': index === 0 && !checkable}"
                            )
                            span(
                                v-if="header.fieldType != 'autocomplete' && (!item.checked || !header.editable)"
                                :style="{width: header.width || '100%'}"
                                ) 
                                span( v-if="header.format === 'percentage'" ) {{ header.fieldType === 'computed' ? header.computed(item) : item[header.value] | formatPercentage }}
                                span( v-else-if="header.format === 'currency'" ) {{ header.fieldType === 'computed' ? header.computed(item) : item[header.value] | mixFormatCurrency }}
                                span( v-else-if="header.format === 'rut'" ) {{ header.fieldType === 'computed' ? header.computed(item) : item[header.value] | mixRUTFilter }}
                                span( v-else-if="isBoolean(item[header.value])")
                                    v-icon(:color="colors.success" v-if="item[header.value] === true") check
                                span( v-else :style="{whiteSpace: header.whiteSpace || 'inherit'}" ) {{ header.fieldType === 'computed' ? header.computed(item) : item[header.value] | formatBooleans}}
                            v-text-field(
                                v-if="item.checked && header.editable && checkable && header.fieldType === 'text'"
                                v-bind="header.fieldProps"
                                v-model="item[header.value]"
                                :style="{width: header.width || 'inherit'}"
                                @keyup='$emit( "change-item", { idx, jdx: index, item } )'
                                )
                            v-autocomplete(v-if="header.fieldType === 'autocomplete'"
                                :readonly="!(item.checked && header.editable && checkable)"
                                v-bind="header.fieldProps"
                                v-model="item[header.value]"
                                :items="header.options"
                                :style="{width: header.width || 'inherit'}"
                                )
                        div.dtcell.px-3.col-actions(
                            v-if="!noActions"
                            :class="{'selected-row': item.checked }"
                            )
                            v-tooltip(v-if="showButton(item)" bottom)
                                v-btn(icon slot="activator")
                                    v-icon(
                                        :color="colors.secondary"
                                        @click="$emit('show', showItem ? item : item[itemKey])"
                                        ) visibility
                                span Detalles
                            slot(:item="item" name="actions")
                            v-tooltip(v-if="deleteButton(item)" bottom)
                                v-btn(icon slot="activator")
                                    v-icon(
                                        :color="colors.danger"
                                        @click="$emit('delete', item[itemKey])"
                                        ) delete
                                span Eliminar
                        div.expand-area(v-if="expandable && expandedIndex === idx" :style="expandableColSpan")
                            slot(name="expansion" :item="item")
        data-table-pagination(v-if="!showAll" v-model="pagination" :length="apiData.lastPage" :from="apiData.from" :to="apiData.to" :total="apiData.total")
        div.d-flex.row(style="width: 100%; height: 58px;")
            slot(name="buttons")
</template>

<script>
import DataTableFilterrs from './partials/DataTableFilters'
import DataTablePagination from './partials/DataTablePagination'
import InputValidations from '@/mixins/InputValidations'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import RUTUtils from '@/mixins/RUTUtils'
import DataTablePaginationVue from './partials/DataTablePagination.vue'
import XLSX from 'xlsx'
import LoadingDialog from '../LoadingDialog/LoadingDialog'
export default {
    name: 'crud-data-table',
    props: {
        /**
         * @description
         * Service containing the methods for providing the table with server side data, pagination and other functions
         */
        service: {
            type: Object,
            default: () => null,
        },
        /**
         * @description
         * Headers array of objects for the Vuetify data-table.
         * Is posible to add a 'editable' attribute to the objects in this array to enable or disable
         * that particular column to be edited.
         * @example
         *  {
         *      text: key,
         *      align: 'left',
         *      sortable: 'false',
         *      value: key,
         *      editable: false,
         *      width: '100px'
         *  }
         */
        headers: {
            type: Array,
            default: () => null,
        },
        /**
         * @description
         * Array of desired filter objects to be used on the datatable.
         * @example
         *  {
         *      field: 'is_consumable',
                value: [],
                label: 'Consumible',
                options: [
                    {
                        text: 'Consumible',
                        value: true,
                    },
                    {
                        text: 'No Consumible',
                        value: false,
                    },
                ],
         *  }
         */
        filters: {
            type: Array,
            default: () => null,
        },
        /**
         * @description
         * Property that enables or disables the checkboxes in the datatable
         */
        checkable: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         * Key to be used to identify the items in the datatable. Defaults to the item ID
         */
        itemKey: {
            type: String,
            default: () => 'id',
        },
        /**
         * @description
         * Enables or disables the sticky header for the data table
         */
        stickyHeader: {
            type: Boolean,
            default: () => true,
        },
        /**
         *
         */
        editableFieldsOverwrites: {
            type: Array,
            default: () => null,
        },
        /**
         * disable pagination and show all results on table
         */
        showAll: {
            type: Boolean,
            default: () => false,
        },
        /**
         * disable actions column
         */
        noActions: {
            type: Boolean,
            default: () => false,
        },
        headerClasses: {
            type: Object,
            default: () => {
                return {
                    secondary: true,
                    'white--text': true,
                }
            },
        },
        expandable: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        showButton: {
            type: Function,
            default: () => true,
        },
        deleteButton: {
            type: Function,
            default: () => true,
        },
        /**
         * @description
         */
        noSearchBox: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        filterOnChange: {
            type: Boolean,
            default: () => false,
        },
        noAutoWidth: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        noExport: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        showItem: {
            type: Boolean,
            default: () => false,
        },
        noVisualHelp: {
            type: Boolean,
            default: () => false,
        },
    },
    data: function() {
        return {
            /**
             * @description
             * List of items fetched from the database
             */
            items: [],
            /**
             * @description
             * Object containing pagination info.
             * It's watched for changes to fetch new data if ordering or page changes.
             */
            pagination: {},
            /**
             * @description
             * Contains metadata of the api fetched along with the db data.
             */
            apiData: {},
            /**
             * Sets the state of the datatable. If true, the datatable will show a loading bar animation.
             */
            loading: true,
            /**
             * List of filters currently applied to the items, used to filter in every db data fetching.
             */
            activeFilters: [],
            /**
             * Content of the searchbox. Used to filter on every db data fetching.
             */
            search: '',
            /**
             * Array contained all checked items if checkboxes are enabled.
             */
            selected: [],
            /**
             * Contains value of selected items before any modifications
             */
            defaultValues: [],
            /**
             * @description
             * Array containing the width of each column, for sticky header purposes
             */
            colWidths: [],
            /**
             * @description
             * Actions column width, for sticky header purposes
             */
            colActionsWidth: 0,
            /**
             * @description
             * Actions column width, for sticky header purposes
             */
            checkColumnWidth: 0,
            /**
             * @description
             * Datatable header's initial position, for sticky header purposes
             */
            headerOffset: 0,
            /**
             * @description
             * Datatable's bottom position, for sticky header purposes
             */
            tableOffset: 0,
            tableWidth: 0,
            isSticky: false,
            dtYScroll: 0,
            stickyHeaderElement: null,
            allChecked: false,
            headerLayout: '',
            itemKeys: [],
            expandedIndex: null,
            showFilters: false,
            visualHelpMode: false,
        }
    },
    computed: {
        /**
         * @description
         * Function that returns the datatable headers.
         * Will use response object properties if no headers are provided by props.
         */
        activeHeaders: function() {
            let headers
            if (this.headers != null) {
                headers = this.headers
            } else if (this.items && this.items.length > 0) {
                headers = []
                for (let key in this.items[0]) {
                    if (this.items[0].hasOwnProperty(key)) {
                        headers.push({
                            text: key,
                            align: 'left',
                            sortable: 'false',
                            value: key,
                            editable: false,
                            width: null,
                        })
                    }
                }
            }
            return headers
        },
        /**
         * @description
         * Function that returns the datatable filters.
         * If no filter props has been passed, will use headers for generating textfield filters.
         */
        propFilters: function() {
            if (this.filters != null) return this.filters
            if (this.activeHeaders && this.activeHeaders.length > 0) {
                return this.activeHeaders.map(header => {
                    return {
                        field: header.value,
                        value: '',
                        label: header.value,
                        options: null,
                    }
                })
            }
        },
        gridLayout: function() {
            let columns = ''
            if (this.checkable) columns += '40px '
            this.activeHeaders.forEach(header => {
                if (
                    header.fieldType &&
                    (!header.width || header.width === 'auto')
                ) {
                    columns += 'auto '
                    return
                }
                if (header.width && header.width !== 0) {
                    columns += header.width + ' '
                } else if (header.type) {
                    if (header.type === 'text') columns += '180px '
                    if (header.type === 'number') columns += '80px '
                } else {
                    columns += 'auto '
                }
            })
            if (!this.noActions) columns += '200px '
            let rows = '0px ' //ancho de las cabeceras
            this.items.forEach(item => {
                rows += 'auto '
            })
            if (this.expandedIndex) rows += 'auto'
            rows = rows.trim()
            columns = columns.trim()
            return {
                headers: {
                    'grid-template-columns': columns,
                    'grid-template-rows': '60px',
                },
                body: {
                    'grid-template-columns': columns,
                    'grid-template-rows': rows,
                },
            }
        },
        headerCheckboxIndeterminate: function() {
            let selectedIndexes = this.selected.map(sel => sel[this.itemKey])
            let currentItemIndexes = this.items.map(itm => itm[this.itemKey])
            let validation = currentItemIndexes.every(idx =>
                selectedIndexes.includes(idx)
            )
            if (!validation) {
                validation = currentItemIndexes.some(idx =>
                    selectedIndexes.includes(idx)
                )
                if (!validation) {
                    this.allChecked = false
                    return false
                } else {
                    this.allChecked = false
                    return true
                }
            } else {
                this.allChecked = true
                return false
            }
        },
        expandableColSpan: function() {
            let length = this.activeHeaders.length
            if (!this.noActions) length++
            if (this.checkable) length++
            console.log(length)
            return {
                'grid-column-start': '1',
                'grid-column-end': 'span ' + length,
            }
        },
        bodyWidth: function() {
            if (this.colWidths.length === 0) return 'calc(100vw - 120px)'
            let sum = this.colWidths.reduce((prev, next) => prev + next, 0)
            if (this.checkable) sum += 40
            if (!this.noActions) sum += 200
            sum += 2
            return sum + 'px'
        },
        printData() {
            let data = []
            let cols = this.activeHeaders.map((header, idx) => {
                return { name: header.text, key: header.text }
            })
            data[0] = cols.map(col => col.name)
            this.items.forEach(item => {
                let row = []
                this.activeHeaders.forEach(header => {
                    if (header.fieldType && header.fieldType === 'computed') {
                        row.push(header.computed(item))
                    } else {
                        row.push(item[header.value])
                    }
                })
                data.push(row)
            })
            return { cols, data }
        },
        exportButtonMargin() {
            if (
                ((this.filters && this.filters.length > 0) ||
                    !this.noSearchBox) &&
                !this.showFilters
            )
                return '-46px'
            return '0px'
        },
    },
    methods: {
        /**
         * @description
         * Handles data fetching from api using the service passed by props
         */
        fetchData: async function(filters = null, pagination = null) {
            this.loading = true
            const response = await this.service.dtFetchData(filters, pagination)
            const dt = response
            const keys = this.selected.map(item => item[this.itemKey])
            if (dt.data.constructor !== Array) {
                dt.data = [dt.data]
            }
            if (keys.length > 0) {
                dt.data = dt.data.map(item => {
                    if (keys.includes(item[this.itemKey]))
                        item = this.selected.find(
                            sel => sel[this.itemKey] === item[this.itemKey]
                        )
                    return item
                })
            }
            this.items = dt.data
            this.apiData = {
                currentPage: dt.current_page,
                lastPage: dt.last_page,
                path: dt.path,
                firstPageUrl: dt.first_page_url,
                prevPageUrl: dt.prev_page_url,
                nextPageUrl: dt.next_page_url,
                lastPageUrl: dt.last_page_url,
                perPage: dt.per_page,
                from: dt.from,
                to: dt.to,
                total: dt.total,
            }
            if (!pagination) {
                this.pagination = {
                    sortBy: null,
                    descending: null,
                    rowsPerPage: dt.per_page,
                    page: dt.current_page,
                }
            }
            this.loading = false
            this.itemKeys = this.items.map(itm => itm[this.itemKey])
            this.expandedIndex = null
            this.$emit('table:empty', this.items.length === 0)
            return
        },
        test(d) {
            console.log(d)
            return false
        },
        /**
         * @description
         */
        handleSearch: function(e) {
            this.search = e
            this.checkAndFetch()
            return
        },
        /**
         * @description
         * checks if a editable field can be modified on the datatable
         */
        editableField: function(props) {
            if (props.selected === undefined) return true
            return false
        },
        /**
         * @description
         * Check all variables that can modify data fetching and fetchs data
         * using those variables
         */
        checkAndFetch: async function() {
            let activeFilters = [...this.activeFilters]
            if (!activeFilters) activeFilters = []
            if (activeFilters)
                activeFilters = this.appendSearchFilter(activeFilters)
            if (activeFilters.length === 0) activeFilters = null
            let pagination = this.pagination
            await this.fetchData(activeFilters, pagination)
        },
        /**
         * @description
         *  Adds the searchbox filter to the server data request
         */
        appendSearchFilter: function(filters) {
            if (this.search && this.search.length >= 3) {
                filters.push({
                    field: 'search',
                    value: [this.search],
                })
            }
            return filters
        },
        /**
         * @description
         * handler for the "check all" checkbox
         */
        toggleAll: function() {
            let selectedKeys = this.selected.map(row => row[this.itemKey])
            let currentKeys = this.items.map(row => row[this.itemKey])

            // Check if every key to be selected is already selected
            let check = currentKeys.every(key => selectedKeys.includes(key))

            if (check) {
                this.selected = this.selected.filter(
                    row => !currentKeys.includes(row[this.itemKey])
                )
            } else {
                this.selected = this.selected.concat(
                    this.items.filter(
                        item => !selectedKeys.includes(item[this.itemKey])
                    )
                )
            }
        },
        /**
         * @description
         * handler for column sorting
         */
        changeSort: function(column) {
            if (this.pagination.sortBy === column) {
                if (this.pagination.descending) {
                    this.pagination.descending = false
                    this.pagination.sortBy = ''
                }
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        sort: function(header) {
            console.log(header)
            if (header.sortable) this.changeSort(header.value)
        },
        /**
         * @description
         * Update the column widths data for headers to adapt to any change on column width
         */
        updateColWidths: function() {
            let colWidths = []
            let headerLayout = ''
            if (this.checkable) headerLayout += '40px '
            this.activeHeaders.forEach((header, idx) => {
                let width = this.$refs['col' + idx][0].offsetWidth
                colWidths.push(width)
                headerLayout += width + 'px '
            })
            if (!this.noActions) headerLayout += '200px '
            this.colWidths = [...colWidths]
            this.headerLayout = {
                'grid-template-columns': headerLayout,
                'grid-template-rows': '40px',
            }
        },
        stickyScrolling: function() {
            const dtheaders = this.$refs['dt-headers']
            if (
                window.pageYOffset >= this.headerOffset
                // && window.pageYOffset <= this.tableOffset
            ) {
                if (this.isSticky) return
                this.stickyHeaderElement = dtheaders.cloneNode(true)
                this.stickyHeaderElement.classList.add('sticky')
                this.stickyHeaderElement.id = 'sticky-header'
                let length = this.activeHeaders.length + 2
                if (this.noActions || !this.checkable)
                    length = this.activeHeaders.length + 1
                if (this.noActions && !this.checkable)
                    length = this.activeHeaders.length
                console.log(length, 'length')
                for (let idx = 0; idx < length; idx++) {
                    console.log(idx)
                    this.stickyHeaderElement.children[idx].style.padding =
                        '0 24px'
                    let icons = this.stickyHeaderElement.children[
                        idx
                    ].getElementsByTagName('i')
                    if (
                        icons &&
                        icons.length > 0 &&
                        idx > 0 &&
                        idx < this.activeHeaders.length + 1
                    )
                        icons[0].style.display = 'none'
                }
                let table = this.$refs.table.$el
                table.insertBefore(this.stickyHeaderElement, table.firstChild)
                this.isSticky = true
            } else {
                if (!this.isSticky) return
                let header = document.getElementById('sticky-header')
                header.parentNode.removeChild(header)
                this.stickyHeaderElement = null
                this.isSticky = false
            }
        },
        selectRow(item, all = false) {
            if (all) item.checked = true
            let validate = this.selected.find(
                sel => sel[this.itemKey] === item[this.itemKey]
            )
            if (item.checked) {
                if (!validate) {
                    if (
                        this.editableFieldsOverwrites &&
                        this.editableFieldsOverwrites.length > 0
                    ) {
                        this.editableFieldsOverwrites.forEach(ovw => {
                            if (ovw.condition(item)) {
                                item[ovw.field] = ovw.value
                            }
                        })
                    }
                    this.selected.push(item)
                    this.selected = [...this.selected]
                    this.defaultValues.push({ ...item })
                    this.defaultValues = [...this.defaultValues]
                }
            } else if (validate && !all) {
                this.selected = this.selected.filter(
                    sel => sel[this.itemKey] !== item[this.itemKey]
                )
                let defval = this.defaultValues.find(
                    def => def[this.itemKey] === item[this.itemKey]
                )
                let validator = this.selected.some(
                    sel => sel[this.itemKey] === this.itemKeys[this.itemKey]
                )
                this.items = this.items.map(itm => {
                    if (itm[this.itemKey] === item[this.itemKey]) {
                        defval.checked = false
                        return defval
                    } else {
                        return itm
                    }
                })
                this.defaultValues = this.defaultValues.filter(
                    def => def[this.itemKey] !== item[this.itemKey]
                )
            }
        },
        checkAll() {
            if (!this.allChecked) {
                this.items.forEach(item => {
                    this.selectRow(item, true)
                })
                this.allChecked = true
            } else {
                this.items.forEach(item => {
                    item.checked = false
                    this.selectRow(item)
                })
                this.allChecked = false
            }
        },
        expandRow(index) {
            if (this.expandedIndex === index) {
                this.expandedIndex = null
                return
            }
            this.expandedIndex = index
        },
        printExcel() {
            let sheet = XLSX.utils.json_to_sheet(
                this.printData.data,
                this.printData.cols
            )
            var new_workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(new_workbook, sheet, 'SheetJS')
            XLSX.writeFile(new_workbook, 'sheet.xlsx')
        },
        toggleVisualHelp() {
            this.visualHelpMode = !this.visualHelpMode
            setTimeout(() => {
                this.updateColWidths()
            }, 50)
        },
        isBoolean(val) {
            if (
                val !== null &&
                val !== undefined &&
                (val === false || val === true)
            )
                return true
            return false
        },
    },
    watch: {
        /**
         * @description
         * watch for pagination changes to fetch new data
         */
        pagination: {
            handler: async function() {
                this.checkAndFetch()
            },
            deep: true,
        },
        /**
         * @description
         * Watch for filters changes to fetch new data
         */
        activeFilters: {
            handler: async function() {
                await this.checkAndFetch()
            },
            deep: true,
        },
        loading: function(val) {
            if (val === false && !this.noAutoWidth) {
                setTimeout(() => {
                    this.updateColWidths()
                }, 100)
            }
        },
        'service.dtFetchData': async function() {
            await this.fetchData()
        },
        selected: {
            handler() {
                this.$emit('select', this.selected)
            },
            deep: true,
        },
    },
    components: {
        'data-table-filters': DataTableFilterrs,
        'data-table-pagination': DataTablePagination,
        // 'loading-dialog': LoadingDialog
        LoadingDialog,
    },
    mixins: [InputValidations, CurrencyUtils, RUTUtils],
    filters: {
        formatBooleans: function(value) {
            if (value === true) return 'SI'
            if (value === false) return 'NO'
            return value
        },
        formatPercentage: ( val ) => {
            return val + ' %'
        }
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        // if (!this.stickyHeader) return
        // window.addEventListener('resize', this.updateColWidths)
    },
    /**
     * @description
     * Initial data loading on component creation
     */
    beforeMount: async function() {
        if (this.service) {
            await this.fetchData()
        }
    },

    // beforeMount: function(){...},
    mounted: function() {
        this.updateColWidths()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function() {
        // window.removeEventListener('resize', this.updateColWidths)
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods

    // TODO -> Watch ref cols widths to set headers widths for fixed headers on scroll
}
</script>

<style lang="scss" scoped>
.sticky {
    position: fixed;
    z-index: 10;
    padding-top: 10px;
    top: 65px;
}
.header-row {
    display: grid !important;
    width: 100%;
}
.dtheader {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    &.col-actions {
        justify-content: center;
    }
}
.expand-area {
    border-left: 1px solid gray;
    border-right: 1px solid gray;
}
.pointer {
    cursor: pointer;
    &:hover {
        font-weight: bolder;
    }
}
.custom-datatable {
    display: grid;
    width: calc(100% - 2px);
    max-width: 100%;
    overflow: hidden;
    .dtcell {
        display: flex;
        align-items: center;
        border-right: 1px solid rgb(224, 220, 220);
        border-bottom: 1px solid rgb(224, 220, 220);
        text-overflow: ellipsis;
        overflow: hidden;
        min-height: 40px;
    }
    .left-cell {
        border-left: 1px solid rgb(224, 220, 220);
    }
    .col-actions {
        justify-content: center;
    }
}
.selected-row {
    background-color: lightgrey;
}
.table-container {
    border-bottom: 1px solid lightgrey;
}
.visual-help-mode {
    font-size: 25px;
}
</style>
